/**
 * paginationのあるAPIに関して、すべての値を取得する。
 * 与えられた引数をlimit毎に分割して、分割された引数毎にAPIを実行する
 * const promises = getAllResourcesWithParams(ids, per_page, async (limitedParams) => {...})
 * const response = await Promise.all(promises).then((r) => r.flat());
 * @module pagination
 * @typeparam T argument array elements type
 * @typeparam S response array elements type
 * @param params argument array
 * @param limit
 * @param apiCall api call method which returns response array
 * @return array of Promise of response array
 */
export const getAllResourcesWithParams = <T, S>(
    params: T[],
    limit: number,
    apiCall: (limitedParams: T[]) => Promise<S[]>
): Promise<S[]>[] => {
    if (params.length <= limit) {
        return [apiCall(params)];
    } else {
        const searchParams = params.slice(0, limit);
        const leftParams = params.slice(limit);
        const result = apiCall(searchParams);
        const leftResult = getAllResourcesWithParams(leftParams, limit, apiCall);
        return [result, ...leftResult];
    }
};

/**
 * paginationのあるAPIに関して、num個の値を取得する。
 * @module pagination
 * @typeparam S response array elements type
 * @param num the number of result
 * @param limit
 * @param startOffset
 * @param apiCall api call method which returns response array. the arguments must have limit and offset
 * @return array of Promise of response array
 */
export const getAllResources = <S>(
    num: number,
    limit: number,
    startOffset: number,
    apiCall: (limit: number, offset: number) => Promise<S[]>
): Promise<S[]>[] => {
    if (num <= limit) {
        return [apiCall(num, startOffset)];
    } else {
        const result = apiCall(limit, startOffset);
        const leftResult = getAllResources(num - limit, limit, startOffset + limit, apiCall);
        return [result, ...leftResult];
    }
};
